import { Box, Container, Divider, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import contactInfo from "../../data/contactInfo.json";
import LoadingSpinner from "./LoadingSpinner";
import PageTitle from "./PageTitle";

const renderTemplate = (template, data) => {
  return template.replace(/{{(.*?)}}/g, (match, key) => {
    const keys = key.trim().split(".");
    return keys.reduce((acc, curr) => (acc && acc[curr] ? acc[curr] : match), data);
  });
};

const formatContent = (content) =>
  content.split("\n").map((line, index) => (
    <React.Fragment key={index}>
      {line}
      <br />
    </React.Fragment>
  ));

const LegalDocument = ({ docType }) => {
  const { i18n } = useTranslation();
  const theme = useTheme();
  const lang = i18n.language;
  const [content, setContent] = useState(null);

  useEffect(() => {
    const loadContent = async () => {
      try {
        const data = await import(`../../i18n/${docType}_${lang}.json`);
        setContent(data.default);
      } catch (error) {
        console.error("Error loading legal document:", error);
      }
    };

    loadContent();
  }, [lang, docType]);

  if (!content) {
    return <LoadingSpinner />;
  }

  return (
    <Container maxWidth="md" sx={{ py: theme.spacing(4) }}>
      <PageTitle text={content.title} sx={{ textAlign: "center", mb: theme.spacing(2) }} />

      <Typography variant="body2" sx={{ textAlign: "center", color: theme.palette.text.secondary }}>
        {content.lastUpdated}
      </Typography>
      <Divider sx={{ my: theme.spacing(3) }} />

      {content.sections.map((section, index) => (
        <Box key={index} sx={{ mb: theme.spacing(4), textAlign: "justify" }}>
          <Typography variant="h6" gutterBottom>
            {renderTemplate(section.heading, { contactInfo })}
          </Typography>
          <Typography variant="body1">{formatContent(renderTemplate(section.content, { contactInfo }))}</Typography>
        </Box>
      ))}
    </Container>
  );
};

export default LegalDocument;
